export default "__VITE_ASSET__BztGekfK__"